/* DON'T EDIT THIS FILE: edit original and run build again */ import {
  TypeCheckerError,
  TypeCheckerErrorResult,
  TypeCheckerErrorType,
  TypeCheckerOkResult,
  TypeCheckerResult,
  TypeCheckerStatus,
} from "./type-checker-types.ts";

export const typeCheckerError = (
  type: TypeCheckerErrorType,
  value: unknown,
  path: string
): TypeCheckerError => ({ type, path, value });

export const typeCheckerErrorResult = (
  type: TypeCheckerErrorType,
  value: unknown,
  path: string,
  errors: TypeCheckerError[] = []
): TypeCheckerErrorResult => {
  return {
    status: TypeCheckerStatus.fail,
    errors: [...errors, typeCheckerError(type, value, path)],
  };
};

export const typeCheckerSchemaFailResult = (
  value: unknown,
  path: string,
  errors?: TypeCheckerError[]
): TypeCheckerErrorResult =>
  typeCheckerErrorResult(TypeCheckerErrorType.schemaFail, value, path, errors);

export const typeCheckerUnexpectedError = (
  value: unknown,
  path: string
): TypeCheckerError =>
  typeCheckerError(TypeCheckerErrorType.unexpectedValue, value, path);

export const typeCheckerUnexpectedValueResult = (
  value: unknown,
  path: string,
  errors?: TypeCheckerError[]
): TypeCheckerErrorResult =>
  typeCheckerErrorResult(
    TypeCheckerErrorType.unexpectedValue,
    value,
    path,
    errors
  );

export const typeCheckerCaughtError = (
  value: unknown,
  path: string,
  originalResult: TypeCheckerErrorResult
): TypeCheckerError => {
  return typeCheckerError(
    TypeCheckerErrorType.caughtError,
    { caught: originalResult, value },
    path
  );
};

export const typeCheckerCaughtResult = <T>(
  value: unknown,
  path: string,
  originalResult: TypeCheckerErrorResult,
  newResult: TypeCheckerResult<T>
): TypeCheckerResult<T> => {
  return {
    ...newResult,
    errors: [
      ...newResult.errors,
      typeCheckerCaughtError(value, path, originalResult),
    ],
  };
};

export const typeCheckerOkResult = <T>(
  value: T,
  errors: TypeCheckerError[] = []
): TypeCheckerOkResult<T> => {
  return { status: TypeCheckerStatus.ok, value, errors };
};
